import { productModel } from "@/models/productModel";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class AppImage extends Vue {
  @Prop({ default: null })
  product: productModel;

  @Prop()
  image: String;

  @Prop()
  fallbackImage: String;

  @Prop()
  type: String;

  @Prop({ default: null })
  width: String;

  @Prop({ default: null })
  height: String;
  @Prop({ default: "middle" })
  valign: String;

  @Prop({ default: false })
  addWrapper: Boolean;

  @Prop({ default: false })
  thumbnail: Boolean;

  @Prop({ default: false })
  fluid: Boolean;

  @Prop({ default: false })
  sticky: Boolean;

  get baseUrl(): string {
    return (process.env.VUE_APP_BASE_URL_IMAGE || '').substring(0, process.env.VUE_APP_BASE_URL_IMAGE.lastIndexOf("/api"));//.trimRight('/api').trimRight('api');
  }
  get getWidth() {
    if (
      this.$props.width == undefined ||
      this.$props.width == null ||
      this.$props.width == "0"
    )
      return "auto";

    return this.$props.width + "px";
  }

  get getHeight() {
    if (
      this.$props.height == undefined ||
      this.$props.height == null ||
      this.$props.height == "0"
    )
      return "auto";

    return this.$props.height + "px";
  }
  get wrapperHeight() {
    if (this.sticky) return "100%";
    return this.getHeight;
  }

  get source() {
    if (this.product && this.product.familyOptions && this.product.familyOptions.length) {
      let optfiligrana = this.product.familyOptions.find(x => x.code == 'FIL_IM');
      if (optfiligrana) {
        if (
          this.image == null ||
          this.image == undefined ||
          this.image == "" ||
          this.image.startsWith("http")
        ) {
          if (this.type == null || this.type == "scale") {
            return this.baseUrl + "/images/wm/" + this.width + "/" + this.height + "/dev" + this.fallbackImage;
          }
          else if (this.type == "crop") {
            return this.baseUrl + "/images/wmc/" + this.width + "/" + this.height + "/dev" + this.fallbackImage;
          }
        } else {
          if (this.type == null || this.type == "scale") {
            return this.baseUrl + "/images/wm/" + this.width + "/" + this.height + "/" + this.image;
          }
          else if (this.type == "crop") {
            return this.baseUrl + "/images/wmc/" + this.width + "/" + this.height + "/" + this.image;
          }
        }
      }
    }

    if (
      this.image == null ||
      this.image == undefined ||
      this.image == "" ||
      this.image.startsWith("http")
    ) {
      if (this.type == null || this.type == "scale") {
        return this.baseUrl + "/images/" + this.width + "/" + this.height + "/dev" + this.fallbackImage;
      }
      else if (this.type == "crop") {
        return this.baseUrl + "/images/" + this.width + "/" + this.height + "/dev" + this.fallbackImage;
      }
    } else {
      if (this.type == null || this.type == "scale") {
        return this.baseUrl + "/images/" + this.width + "/" + this.height + "/" + this.image;
      }
      else if (this.type == "crop") {
        return this.baseUrl + "/images/" + this.width + "/" + this.height + "/" + this.image;
      }
    }

    
    return "";
  }
}
